import React from 'react';

interface CountAction {
  label: string;
  onClick: () => void;
  icon?: React.ReactNode;
}

interface CountTrackerProps {
  dealtCount: number;
  decksRemaining: number | string;
  numDecks: number;
  penetration: number;
  rightContent?: React.ReactNode;
  action?: CountAction;
  className?: string;
}

export const CountTracker: React.FC<CountTrackerProps> = ({
  dealtCount,
  decksRemaining,
  numDecks,
  penetration,
  rightContent,
  action,
  className = ''
}) => {
  return (
    <div className={`bg-gray-800 rounded-xl p-3 sm:p-4 shadow-lg ${className}`}>
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="flex flex-wrap items-center gap-4 sm:gap-6">
          <div className="text-center">
            <div className="text-xs text-gray-400">Cards Dealt</div>
            <div className="text-xl sm:text-2xl font-bold text-white">{dealtCount}</div>
          </div>
          <div className="text-center">
            <div className="text-xs text-gray-400">Decks Left</div>
            <div className="text-xl sm:text-2xl font-bold text-white">{decksRemaining}</div>
          </div>
          <div className="text-center">
            <div className="text-xs text-gray-400">{numDecks} Decks</div>
            <div className="text-sm text-gray-300">{penetration}% Pen</div>
          </div>
          {action && (
            <button
              onClick={action.onClick}
              className="group px-3 py-2 bg-gray-700 hover:bg-gray-600 text-gray-300 hover:text-white rounded-lg font-semibold transition-colors text-sm flex items-center gap-1.5"
            >
              {action.icon}
              {action.label}
            </button>
          )}
        </div>
        {rightContent}
      </div>
    </div>
  );
};

